import React, { useEffect } from "react";
import { CardSection } from "../../Common/FormComponents";
import { fs } from "../../Common/FormComponents";

const PropertyImagesSection = ({ formData, handleImagesChange }) => {
  const images = Array.isArray(formData.images) ? formData.images : [];

  useEffect(() => {
    return () => {
      images.forEach((image) => {
        if (image.url && image.url.startsWith("blob:")) URL.revokeObjectURL(image.url);
      });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleFileSelect = (e) => {
    const files = Array.from(e.target.files);
    const newImages = files.map((file) => ({
      file,
      url: URL.createObjectURL(file),
      caption: "",
      isPrimary: images.length === 0,
      isNew: true,
    }));
    handleImagesChange([...images, ...newImages]);
  };

  const handleRemoveImage = (index) => {
    const updated = images.filter((_, i) => i !== index);
    if (images[index]?.isPrimary && updated.length > 0) updated[0].isPrimary = true;
    handleImagesChange(updated);
  };

  const handleSetPrimary = (index) => {
    handleImagesChange(images.map((img, i) => ({ ...img, isPrimary: i === index })));
  };

  const handleCaptionChange = (index, caption) => {
    handleImagesChange(images.map((img, i) => (i === index ? { ...img, caption } : img)));
  };

  return (
    <CardSection title="Images">
      <div>
        <label style={fs.label}>Property Images</label>
        <input
          style={{ ...fs.input, padding: "6px 8px", cursor: "pointer" }}
          type="file"
          accept="image/*"
          multiple
          onChange={handleFileSelect}
        />
        <div style={fs.helpText}>
          {images.length > 0
            ? `${images.length} image${images.length === 1 ? "" : "s"} added. Choose files again to add more. `
            : ""}
          Select multiple images for this property. The first image will be set as primary.
        </div>
      </div>

      {images.length > 0 && (
        <div style={{ display: "flex", flexWrap: "wrap", gap: 12, marginTop: 16 }}>
          {images.map((image, index) => (
            <div key={index} style={{ position: "relative", width: 150 }}>
              <img
                src={typeof image === "string" ? image : image.url || ""}
                alt={`Property ${index + 1}`}
                style={{ width: 150, height: 150, objectFit: "cover", borderRadius: 8, border: "1px solid #e5e7eb", display: "block" }}
                onError={(e) => { e.target.src = "https://via.placeholder.com/150?text=Image"; }}
              />
              {image.isPrimary && (
                <span style={{ position: "absolute", top: 6, left: 6, background: "#1E40AF", color: "#fff", fontSize: 10, fontWeight: 600, padding: "2px 7px", borderRadius: 10 }}>
                  Primary
                </span>
              )}
              <div style={{ position: "absolute", top: 6, right: 6, display: "flex", gap: 4 }}>
                {!image.isPrimary && (
                  <button
                    type="button"
                    title="Set as primary"
                    onClick={() => handleSetPrimary(index)}
                    style={{ background: "rgba(255,255,255,0.9)", border: "1px solid #d1d5db", borderRadius: 5, padding: "2px 6px", cursor: "pointer", fontSize: 12 }}
                  >
                    ★
                  </button>
                )}
                <button
                  type="button"
                  title="Remove image"
                  onClick={() => handleRemoveImage(index)}
                  style={{ background: "rgba(255,255,255,0.9)", border: "1px solid #FECACA", borderRadius: 5, padding: "2px 6px", cursor: "pointer", fontSize: 12, color: "#991B1B" }}
                >
                  ✕
                </button>
              </div>
              <input
                type="text"
                placeholder="Caption (optional)"
                value={image.caption || ""}
                onChange={(e) => handleCaptionChange(index, e.target.value)}
                style={{ ...fs.input, marginTop: 6, fontSize: 11, padding: "4px 7px" }}
              />
            </div>
          ))}
        </div>
      )}
    </CardSection>
  );
};

export default PropertyImagesSection;
